import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const BorderIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 3H21M21 3V21M21 21H3M3 21V3"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M9 3V21M15 3V21M3 9H21M3 15H21"
      stroke="currentColor"
      strokeDasharray="2 2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.5"
    />
  </svg>
);

BorderIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(BorderIcon);
